"use strict";
const debug = require('debug')('mAccount:package');

export class UserError extends Error {
	which?:any;
}
